import { Component, OnInit, Inject, NgZone } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ProfileService } from 'src/app/pages/account/services/profile.service';
import { Router } from '@angular/router';
import { LsHelperService } from '../../services/ls-helper.service';

@Component({
  selector: 'prgov-profile-selection-modal',
  templateUrl: './profile-selection-modal.component.html',
  styleUrls: ['./profile-selection-modal.component.scss']
})
export class ProfileSelectionModalComponent implements OnInit {

  profileList: any[] = [];
  selectedProfile: any = null;
  currentProfile: any = null;
  loading: boolean = false;
  errorMessage: string = '';
  page = 1;
  size = 10;
  term: any = null;
  
  constructor(
    public dialogRef: MatDialogRef<ProfileSelectionModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private profileService: ProfileService,
    private ngZone: NgZone,
    private router: Router,
    private ls: LsHelperService
  ) {
    // Obtener el perfil actual de los datos del diálogo
    if (data && data.currentProfile) {
      this.currentProfile = data.currentProfile;
      this.selectedProfile = data.currentProfile.Id || data.currentProfile.id;
    }
  }

  ngOnInit() {
    // Usamos setTimeout para evitar ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      this.loadProfiles();
    });
  }

  /**
   * Carga la lista de perfiles médicos disponibles
   */
  loadProfiles() {
    this.loading = true;
    this.errorMessage = '';
    
    this.profileService
      .search({
        term: this.term == '' ? 'null' : this.term,
        pageNumber: this.page,
        pageSize: this.size,
      })
      .then((data: any) => {  
        this.ngZone.run(() => {
          this.loading = false;
          this.profileList = data;
          console.log('Estructura de profileList:', data && data.length > 0 ? data[0] : data);
        });
      })
      .catch(error => {
        this.ngZone.run(() => {
          this.loading = false;
          console.error('Error al cargar perfiles:', error);
          this.errorMessage = 'No se pudieron cargar los perfiles. Por favor, intente nuevamente.';
        });
      });
  }

  /**
   * Selecciona un perfil de la lista
   * @param profile El perfil seleccionado
   */
  onSelectProfile(profile: any) {
    this.selectedProfile = profile.Id || profile.id;
  }

  /**
   * Verifica si un perfil está seleccionado
   * @param profile El perfil a verificar
   * @returns true si el perfil está seleccionado
   */
  isProfileSelected(profile: any): boolean {
    return (profile.Id || profile.id) === this.selectedProfile;
  }

  /**
   * Verifica si un perfil es el actual
   * @param profile El perfil a verificar
   * @returns true si el perfil es el actual
   */
  isCurrentProfile(profile: any): boolean {
    if (!this.currentProfile) return false;
    return (profile.Id || profile.id) === (this.currentProfile.Id || this.currentProfile.id);
  }

  /**
   * Selecciona un perfil y cierra el modal
   */
  selectProfile() {
    if (this.selectedProfile) {
      this.profileService.setSelectedProfileId(this.selectedProfile);
      this.ls.set('currentProfileId', this.selectedProfile);
      
      // Buscar el perfil completo en la lista
      const selectedProfileObj = this.profileList.find(profile => 
        (profile.Id || profile.id) === this.selectedProfile);
      
      if (selectedProfileObj) {
        this.dialogRef.close(selectedProfileObj);
      }
    }
  }

  /**
   * Cancela la selección y cierra el modal
   */
  cancel() {
    this.dialogRef.close();
  }
  
  /**
   * Cierra el diálogo y redirige a la página para crear un nuevo perfil
   */
  addNewProfile() {
    this.dialogRef.close();
    this.router.navigate(['/account/profiles/new']);
  }
} 